module.exports = __webpack_public_path__ + "static/fonts/SourceHanSansCN-Normal.4bf258e.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/SourceHanSansCN-Normal.otf
// module id = rYMm
// module chunks = 1